import React from 'react';

const NotAuthorised = () => {
  return (
    <div>
      <span>You are not authorized to access this page</span>
    </div>
  );
};

export default NotAuthorised;

// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Button } from 'reactstrap';

// const NotAuthorised = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="container-fluid d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
//       <div className="row justify-content-center w-100">
//         <div className="col-md-6 col-lg-5">
//           <div className="card shadow-lg border-0">
//             <div className="card-body text-center p-5">
//               {/* Icon */}
//               <div className="mb-4">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="100"
//                   height="100"
//                   fill="currentColor"
//                   className="text-danger"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
//                   <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
//                 </svg>
//               </div>

//               {/* Title */}
//               <h2 className="mb-3 fw-bold">Access Denied</h2>

//               {/* Message */}
//               <p className="text-muted mb-4 fs-5">
//                 You do not have permission to access this page.
//               </p>

//               {/* Additional Info */}
//               <p className="text-muted small mb-4">
//                 This page requires specific permissions that are not assigned to your account.
//                 Please contact your administrator if you believe you should have access.
//               </p>

//               {/* Action Buttons */}
//               <div className="d-flex gap-3 justify-content-center">
//                 <Button
//                   color="secondary"
//                   outline
//                   onClick={() => navigate(-1)}
//                   className="px-4"
//                 >
//                   Go Back
//                 </Button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NotAuthorised;
